import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BookingConflict } from '../../../services/externalDataService.service';

/**
 * Lists the Pending/Confirmed appointments that block a zone or holiday change (API 409),
 * with links to each appointment so they can be rescheduled or cancelled first.
 */
@Component({
  selector: 'app-booking-conflict-panel',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './booking-conflict-panel.component.html',
})
export class BookingConflictPanelComponent {
  @Input({ required: true }) conflict!: BookingConflict;
  @Output() dismiss = new EventEmitter<void>();

  get hiddenCount(): number {
    return Math.max(0, this.conflict.totalCount - this.conflict.appointments.length);
  }
}
